
// ProdutosPage.js

import React, { useState, useEffect } from 'react';
import Header from '../../components/Header.js';
import ProdutoModal from '../../components/ProdutoModal.js';
import { useTheme } from '../../contexts/ThemeContext.js';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../config/axiosConfig';
import '../../components/ProdutosPage.css';

function ProdutosPage() {
  const [produtos, setProdutos] = useState([]);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const { theme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Usando o axiosConfig para buscar materiais
    api.get('/produtos/listarprodutos')
      .then((response) => {
        if (Array.isArray(response.data)) {
          setProdutos(response.data); // Garante que estamos trabalhando com um array
        } else {
          console.error('A resposta não contém um array de produtos:', response.data);
        }
      })
      .catch((error) => {
        console.error('Erro ao buscar produtos:', error);
      });
  }, []);

  const handleFechar = () => {
    const previousPage = location.state?.from || '/home';
    navigate(previousPage);
  };

  const handleAdicionarProduto = (produto) => {
    const codigoExistente = produtos.some(p => p.codpro === produto.codpro && p.id !== produto.id);
    if (codigoExistente) {
      window.alert('Atenção... Código do Produto já existe no Cadastro.');
    } else {
      const method = produto.id ? 'PUT' : 'POST';
      const url = produto.id ? '/produtos/alterarproduto' : '/produtos/cadastrarproduto';
      api({
        url,
        method,
        data: produto,
      })
        
        .then((response) => {
          const data = response.data;
          if (data && data.codpro && data.produto) {
            console.log('Produto salvo:', data);
            if (produto.id) {
              setProdutos(produtos.map(p => (p.id === produto.id ? data : p)));
            } else {
              setProdutos([...produtos, data]);
            }
            setProdutoSelecionado(null);
          } else {
            console.error('Dados inválidos recebidos ao salvar o produto:', data);
          }
        })
        .catch((error) => {
          console.error('Erro ao salvar produto:', error);
        });
    }
  };

  const handleSelecionarProduto = (indice) => {
    setProdutoSelecionado(produtos[indice]);
  };

  const handleExcluirProduto = (indice) => {
    const produto = produtos[indice];
     api.delete(`/produtos/excluirproduto/${produto.id}`)
      .then(() => {
        setProdutos(produtos.filter((_, i) => i !== indice));
      })
      .catch((error) => {
        console.error('Erro ao excluir produto:', error);
      });
  };

  // Função para formatar os valores para BRL
  const formatarValorBRL = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };


  return (
    <div style={{ 
      backgroundColor: theme.background, 
      color: theme.color,
      minHeight: 'calc(100vh - 20px)',
      width: '100%',
      paddingTop: '10px'
    }}>
      <Header selectedCompany={localStorage.getItem('selectedCompany')} />
      
      <div className="title-actions-container">
        <button 
          onClick={() => setProdutoSelecionado({ codpro: '', produto: '', valvenda: '' })} 
          className="btn btn-primary" 
          style={{ padding: '5px 10px', fontSize: '14px', marginLeft: '100px' }}
        >
          Adicionar
        </button>
        <h3>Tabela de Produtos - Vendas</h3>
        <button 
          onClick={handleFechar} 
          className="btn btn-primary" 
          style={{ padding: '5px 10px', fontSize: '14px', marginRight: '100px' }}
        >
          Fechar
        </button>
      </div>

      
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th className="col-codigo">Código</th>
              <th className="col-produto">Produto</th>
              <th className="col-valor">Valor</th>
              <th className="col-selecionar">Seleção</th>
              <th className="col-excluir">Excluir</th>
            </tr>
          </thead>
          <tbody>
            {produtos.map((obj, indice) => (
              <tr key={indice}>
                <td>{obj.codpro}</td>
                <td>{obj.produto}</td>
                <td>{formatarValorBRL(obj.valvenda)}</td>
                <td>
                  <button 
                    onClick={() => handleSelecionarProduto(indice)} 
                    className="btn btn-success" 
                    style={{ padding: '4px 6px', fontSize: '12px' }}
                  >
                    Sel
                  </button>
                </td>
                <td>
                  <button 
                    onClick={() => handleExcluirProduto(indice)} 
                    className="btn btn-danger" 
                    style={{ padding: '4px 8px', fontSize: '12px' }}
                  >
                    Excluir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {produtoSelecionado && (
        <ProdutoModal 
          produto={produtoSelecionado} 
          onSave={handleAdicionarProduto} 
          onClose={() => setProdutoSelecionado(null)} 
        />
      )}
    </div>
  );
}

export default ProdutosPage;

//<td>{obj.valvenda}</td>